import { useRouter } from 'next/router';
import { Heading, Page, Text } from '@zillow/constellation-10';
import { TermsHtml } from '@zg-rentals/id-verification';

const experianUse = 'Experian-Terms-of-Use';
const experianPrivacy = 'Experian-Privacy-Policy';
const experianNotice = 'Experian-Notice-to-Users';
const experianReminder = 'Experian-Terms-Reminder';
const cicUse = 'CIC-Terms-of-Use';

// /terms/[termId] is a legacy route - used only in native webviews
export default function TermsPage() {
  const router = useRouter();
  const { termId } = router.query as { termId: string };

  let html = '';
  if (termId === experianUse) {
    html = TermsHtml.ExperianTac;
  } else if (termId === experianPrivacy) {
    html = TermsHtml.ExperianPp;
  } else if (termId === experianNotice) {
    html = TermsHtml.NoticeToUsers;
  } else if (termId === experianReminder) {
    html = TermsHtml.ExperianTermsReminder;
  } else if (termId === cicUse) {
    html = TermsHtml.CicTac;
  }

  function getTitleForTerm() {
    switch (termId) {
      case experianUse:
        return 'Experian Terms and Conditions';
      case experianPrivacy:
        return 'Experian Privacy Policy';
      case experianNotice:
        return 'Experian Notice to Users';
      case experianReminder:
        return 'Terms and Policies';
      case cicUse:
        return 'CIC Terms and Conditions';
      default:
        return '';
    }
  }
  return (
    <Page.Root
      css={{
        background: 'white',
      }}
    >
      <Page.Content>
        <Heading level={1} textStyle="responsive.heading-md">
          {getTitleForTerm()}
        </Heading>
        {/* @ts-expect-error no children when using dangerouslySetInnerHTML */}
        <Text dangerouslySetInnerHTML={{ __html: html }} />
      </Page.Content>
    </Page.Root>
  );
}
